import { Component } from '@angular/core';

@Component({
    selector: 'app-desktop-navbar',
    templateUrl: './desktop-navbar.component.html',
})
export class DesktopNavbarComponent {}
